import { Divider, Grid } from "@mui/material";
import type { DriverFormType } from "./driver-form-simple";

const businessStatusOptions = [
  { name: "Entreprise", value: "COMPANY" },
  { name: "Chauffeur", value: "DRIVER" },
];

type Props = {
  form: DriverFormType;
};

export function DriverInfoFields({ form }: Props) {
  return (
    <>
      {/* Row 1: Personal info */}
      <Grid size={{ xs: 12, md: 6 }}>
        <form.AppField name="lastName">{(field) => <field.TextField label="Nom" />}</form.AppField>
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <form.AppField name="firstName">
          {(field) => <field.TextField label="Prénom" />}
        </form.AppField>
      </Grid>

      {/* Row 2: Contact */}
      <Grid size={{ xs: 12, md: 6 }}>
        <form.AppField name="email">
          {(field) => <field.TextField label="Email" type="email" />}
        </form.AppField>
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <form.AppField name="phoneNumber">
          {(field) => <field.PhoneField label="Téléphone" />}
        </form.AppField>
      </Grid>

      {/* Row 3: Birth date */}
      <Grid size={{ xs: 12 }}>
        <form.AppField name="birthDate">
          {(field) => <field.DateField label="Date de naissance" />}
        </form.AppField>
      </Grid>

      {/* Divider */}
      <Grid size={{ xs: 12 }}>
        <Divider sx={{ my: 2 }} />
      </Grid>

      {/* Row 4: Address */}
      <Grid size={{ xs: 12 }}>
        <form.AppField name="address.address">
          {(field) => <field.TextField label="Adresse" />}
        </form.AppField>
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <form.AppField name="address.postalCode">
          {(field) => <field.TextField label="Code postal" />}
        </form.AppField>
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <form.AppField name="address.city">
          {(field) => <field.TextField label="Ville" />}
        </form.AppField>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <form.AppField name="address.addressPrecision">
          {(field) => <field.TextField label="Complément d'adresse" />}
        </form.AppField>
      </Grid>

      {/* Divider */}
      <Grid size={{ xs: 12 }}>
        <Divider sx={{ my: 2 }} />
      </Grid>

      {/* Row 5: Company */}
      <Grid size={{ xs: 12, md: 6 }}>
        <form.AppField name="business_status">
          {(field) => <field.SelectField label="Statut" options={businessStatusOptions} />}
        </form.AppField>
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <form.AppField name="company">
          {(field) => <field.TextField label="Société" />}
        </form.AppField>
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <form.AppField name="siret">{(field) => <field.TextField label="SIRET" />}</form.AppField>
      </Grid>

      {/* Divider */}
      <Grid size={{ xs: 12 }}>
        <Divider sx={{ my: 2 }} />
      </Grid>

      {/* Row 6: License */}
      <Grid size={{ xs: 12, md: 6 }}>
        <form.AppField name="drivingPermitNumber">
          {(field) => <field.TextField label="N° Permis" />}
        </form.AppField>
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <form.AppField name="drivingLicenseDate">
          {(field) => <field.DateField label="Date d'obtention du permis" />}
        </form.AppField>
      </Grid>

      {/* Row 7: Boolean fields */}
      <Grid size={{ xs: 12, md: 6 }}>
        <form.AppField name="truck_ownership_status">
          {(field) => <field.SwitchField label="Camion propriété" />}
        </form.AppField>
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <form.AppField name="wgarage">
          {(field) => <field.SwitchField label="WGarage" />}
        </form.AppField>
      </Grid>

      {/* Divider */}
      <Grid size={{ xs: 12 }}>
        <Divider sx={{ my: 2 }} />
      </Grid>

      {/* Row 9: Payment */}
      <Grid size={{ xs: 12 }}>
        <form.AppField name="iban">{(field) => <field.TextField label="IBAN" />}</form.AppField>
      </Grid>

      {/* Divider */}
      <Grid size={{ xs: 12 }}>
        <Divider sx={{ my: 2 }} />
      </Grid>
    </>
  );
}
